<!-- 
  Session Timeout Dialog Component
  Location: alfresco-content-app/app/src/app/components/session-timeout/session-timeout-dialog.component.html
-->

<div class="session-timeout-overlay" *ngIf="showDialog">
  <div class="session-timeout-dialog">
    
    <!-- Warning Icon -->
    <div class="dialog-icon">
      <span class="material-icons">schedule</span>
    </div>
    
    <!-- Title -->
    <h2 class="dialog-title">Session Expiring Soon</h2>
    
    <!-- Message -->
    <p class="dialog-message">
      Your session will expire in <strong>{{ formatTime() }}</strong> due to inactivity.
    </p>
    
    <!-- Countdown Timer -->
    <div class="countdown-timer">
      <div class="timer-circle">
        <span class="timer-value">{{ remainingMinutes }}:{{ remainingSecondsDisplay.toString().padStart(2, '0') }}</span>
      </div>
    </div>
    
    <!-- Sub-message -->
    <p class="dialog-submessage">
      Click "Stay Logged In" to continue your session, or you will be automatically logged out.
    </p>
    
    <!-- Actions -->
    <div class="dialog-actions">
      <button class="btn btn-secondary" (click)="logout()">
        <span class="material-icons">logout</span>
        Logout Now
      </button>
      <button class="btn btn-primary" (click)="extendSession()">
        <span class="material-icons">check_circle</span>
        Stay Logged In
      </button>
    </div>
    
  </div>
</div>